<template>
  <div class="d-flex">
    <div class="card m-1 flex-fill">
      <div class="card-body d-flex justify-content-center align-items-center maadi-dark-card">
        <div>
          <div class="text-center" style="font-size: 5em; line-height: 1em; font-weight: 500">
            {{ membersCount }}
          </div>
          <div class="text-center">
            MEMBERS
          </div>
        </div>
      </div>
    </div>
    <div class="card m-1 flex-fill">
      <div class="card-body maadi-dark-card">
        <membership-type-chart v-bind:members="members"/>
      </div>
    </div>
    <div class="card m-1 flex-fill">
      <div class="card-body maadi-dark-card">
        <membership-category-chart v-bind:members="members"/>
      </div>
    </div>
  </div>
</template>

<script>
import MembershipDashboardMixin from './MembershipDashboardMixin'
import MembershipCategoryChart from './MembershipCategoryChart'
import MembershipTypeChart from './MembershipTypeChart'
export default {
  name: '',
  props: [],
  mixins: [MembershipDashboardMixin],
  components: {
    MembershipTypeChart,
    MembershipCategoryChart
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/membership/MembershipOverviewDashboard.vue